import { FC } from 'react'
import { Skeleton, Token } from '@revolut-internal/ui-kit'

import { chatInputWidth } from './ChatInput.constants'

export const ChatInputLoading: FC = () => {
  return (
    <Skeleton width={chatInputWidth} height={112} borderRadius={Token.radius.widget} />
  )
}
